module.exports = __webpack_public_path__ + "static/sl5-580f3646ea787cfcd3f94fed94748af7.jpg";